import { bridgeReady } from './jsbridge-client';

/**
 * EventEmitter infrastructure for JSBridge Swift → JS communication.
 *
 * Event types are auto-generated by JSBridgeBuildTool in JSBridge/index.d.ts.
 * Events are subscribed via window.jsb.BridgeName.onEventName().
 *
 * Usage:
 * ```ts
 * // Subscribe to Swift → JS events
 * const unsubscribe = window.jsb.MessagesBridge.onConversationMessageChanged((event) => {
 *   console.log(event);
 * });
 *
 * // Cleanup
 * unsubscribe();
 * ```
 */

type Listener<T> = (data: T) => void;

class JSBridgeEventEmitter {
  private listeners = new Map<string, Set<Listener<unknown>>>();

  on(event: string, listener: Listener<unknown>): () => void {
    bridgeReady();
    if (!this.listeners.has(event)) {
      this.listeners.set(event, new Set());
    }
    this.listeners.get(event)!.add(listener);

    // Return unsubscribe function
    return () => this.off(event, listener);
  }

  off(event: string, listener: Listener<unknown>): void {
    this.listeners.get(event)?.delete(listener);
  }

  // Internal emit for Swift calls
  _emit(event: string, data: unknown): void {
    this.listeners.get(event)?.forEach(listener => listener(data));
  }
}

// Create singleton instance
export const jsbEvents = new JSBridgeEventEmitter();

// Mount to window for Swift to call
window.jsbEvents = {
  emit: (event, data) => jsbEvents._emit(event, data),
};
